import { render, staticRenderFns } from "./QTab.vue?vue&type=template&id=4c2e5085&scoped=true"
import script from "./QTab.vue?vue&type=script&lang=js"
export * from "./QTab.vue?vue&type=script&lang=js"
import style0 from "./QTab.vue?vue&type=style&index=0&id=4c2e5085&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2e5085",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c2e5085')) {
      api.createRecord('4c2e5085', component.options)
    } else {
      api.reload('4c2e5085', component.options)
    }
    module.hot.accept("./QTab.vue?vue&type=template&id=4c2e5085&scoped=true", function () {
      api.rerender('4c2e5085', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/q-tabs/QTab.vue"
export default component.exports